import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';

// Same boundary as the `max-width: 768px` media queries.
export const isMobileViewport = (): boolean => window.innerWidth <= SIDEBAR_MOBILE_BREAKPOINT;
